<template>
  <b-modal
    id="dmViewModal"
    v-model="modal.show"
    size="xl"
    :title="'View Record Data'"
    :ok-disabled="modal.loading"
    :cancel-disabled="modal.loading"
    body-class="p-0"
    hide-footer
    @hidden="hideViewRecordModal"
  >
    <content-spinner
      :show="modal.loading"
      :fullscreen="true"
    />
    <complex-table-view
      v-if="!modal.loading"
      :small="true"
      :items="items"
      :fields="tableFields"
      :total-rows="items.length"
      :is-history-modal="true"
      :modal-name="'view-record-data'"
      selected="all"
      @sort-changed="onSortChanged"
      @filter="filterData"
    />
  </b-modal>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ComplexTableView from './components/ComplexTableView';
import ContentSpinner from '../ContentSpinner';
import filterMixin from '../../mixins/filter.mixin';
import moment from 'moment';

const {mapState, mapActions, mapGetters} = createNamespacedHelpers('dataManagement');


export default {
  name: 'ViewRowModal',
  components: {ContentSpinner, ComplexTableView},
  mixins: [filterMixin],
  data() {
    return {
      items: [],
    };
  },
  watch: {
    ['modal.data']() {
      this.items = [...this.modal.data];
    },
  },
  computed: {
    ...mapGetters(['fields']),
    ...mapState({
      modal: state => state.table.viewModal,
    }),
    ...mapState(['permissionTypes']),
    tableFields() {
      return this.sortedFields.filter(f => {
        if (f.key === '__IsDeleted__') {
          return true;
        }
        if ([this.permissionTypes.none, this.permissionTypes.deny].includes(f.currentUserPermissionLevel)) {
          return false;
        }

        const show = f.displayInTable && !f.isPrimaryKey;

        if (!this.readOnly) {
          //show = show && !(f.isInternal && f.dataTypeName === 'createdDate')
          if (f.dataTypeName === 'createdDate') {
            f.displayName = 'Created Date';
          }
          if (f.dataTypeName === 'lastUpdatedDate') {
            f.displayName = 'Last Update Date';
          }
          if (f.dataTypeName === 'lastUpdatedBy') {
            f.displayName = 'Updated By';
          }
        }

        return show;
      });
    },
    sortedFields() {
      const internalFields = [];
      const fields = this.fields.reduce((fields, field) => (field.isInternal ? internalFields.push(field) : fields.push(field), fields), []);
      return [...fields, ...internalFields, {
        key: '__IsDeleted__',
        name: '__IsDeleted__',
        label: 'Is Deleted',
        tdClass: 'px-2 align-middle text-center pr-4',
        thStyle: {width: '150px'},
        dataTypeName: 'boolean',
        thClass: 'text-center pr-4',
      }];
    },
  },
  methods: {
    ...mapActions(['hideViewRecordModal']),
    onSortChanged(e) {
      this.items.sort(function (a, b) {
        if (a[e.sortBy] < b[e.sortBy]) {
          return e.sortDesc ? 1 : -1;
        }
        if (a[e.sortBy] > b[e.sortBy]) {
          return e.sortDesc ? -1 : 1;
        }
        return 0;
      });
    },
    filterData(filters) {
      const filter = filters.filter;
      this.isFiltered = true;
      this.items = this.modal.data.filter((item) => {
        for (const filterFieldName in filter) {
          if (!filter.hasOwnProperty(filterFieldName)) {
            continue;
          }
          const field = this.tableFields.find((f) => f.name === filterFieldName);
          if (field.dataTypeName === this.fieldValues.text && !this.textFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          } else if ([this.fieldValues.wholeNumber, this.fieldValues.decimalNumber, this.fieldValues.floatNumber].includes(field.dataTypeName) && !this.numberFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          } else if (field.dataTypeName === this.fieldValues.boolean && !this.booleanFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          } else if (field.dataTypeName === this.fieldValues.lookup && !this.lookupFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          } else if (field.dataTypeName === this.fieldValues.parentChildHierarchy && !this.hierarchyFilter(filter[filterFieldName], item[filterFieldName], field)) {
            return false;
          } else if (this.isFieldDatetime(field) && !this.dateFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          } else if (this.isFieldInternal(field) && !this.internalFieldFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          }
        }
        return true;
      });
    },
    isFieldDatetime(field) {
      return [this.fieldValues.dateTime, this.fieldValues.createdDate, this.fieldValues.lastUpdatedDate].includes(field.dataTypeName);
    },
    isFieldInternal(field) {
      return [this.fieldValues.lastUpdatedBy].includes(field.dataTypeName);
    },
    internalFieldFilter(filteredField, uploadField) {
      return this.textFilter(filteredField, uploadField);
    },
  },
};
</script>

<style scoped>


</style>
